import React from "react";
import { Dialog, FlatButton } from "material-ui";
import RecurringUpdateOptions, {
  OPTIONS
} from "./recurring-update-options.jsx";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      option: OPTIONS.CURRENT
    };
  }
  getStyles() {
    return {
      actions: {
        marginTop: 15
      },
      dialogTitle: {
        borderBottom: "none"
      },
      dialogActionsContainer: {
        borderTop: "none"
      }
    };
  }
  render() {
    const styles = this.getStyles();
    return (
      <Dialog
        title={this.props.title}
        titleStyle={styles.dialogTitle}
        actionsContainerStyle={styles.dialogActionsContainer}
        openImmediately={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={this.props.onRequestClose} />,
          <FlatButton
            primary={true}
            label={this.props.buttonTitle}
            onTouchTap={e => this.props.onSave(this.state.option)}
          />
        ]}
        modal={true}
        open={true}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        bodyStyle={{ overflowY: "visible" }}
        onRequestClose={this.props.onRequestClose}
      >
        <RecurringUpdateOptions
          value={this.state.option}
          onChange={v => this.setState({ option: v })}
        />
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/events/recurring-update-modal.jsx